import React, { useEffect, useState } from "react";
import ogimage from "../assets/Images/ogImages/OG_DigirytePods.jpg";

import { BASE_SITE_URL } from "../shared/constants";
import HeroTabSection from "../components/HeroTabSection";
import Layout from "../components/layouts/layout";

const DigirytePods = () => {
  

  return (
    <Layout
      seo={{
        title: "Our Pod Model | DigiRyte",
        ogtitle: "Our Pod Model | DigiRyte",
        description:
          "DigiRyte assists in hiring, managing, and implementing all the relevant human resource functions for building and scaling reliable and dynamic remote teams.",
        ogimage: ogimage,
        ogurl: `${BASE_SITE_URL}/digiryte-pods`,
        keywords:
          "remote teams, hiring, managing, human resources, scaling teams, dynamic teams",
      }}
    >
      <HeroTabSection />
    </Layout>
  );
};

export default DigirytePods;
